import { MdKeyboardArrowRight, MdNotifications } from "react-icons/md";
import Foto from "../../assets/imgs/fotoPeriodico.svg";
import Foto2 from "../../assets/imgs/fotoSaudeMulher.svg";
import CardAnnouncements from "../../components/cardAnnouncements/CardAnnouncements";
import CardResult from "../../components/cardResult/CardResult";
import ContainerWithSidebar from "../../components/UI/containerWithSidebar/ContainerWithSidebar";
import {
  GeneralContainer,
  H1,
  H2,
  TextLink,
} from "../../components/UI/generalLayout/Layout.styled";
import * as collaboratorInitial from "../../store/actions/collaboratorInitial";
import * as exams from "../../store/actions/exams";
import { AppointmentService } from "../../core/http/service/AppointmentService";
import OpenAppointmentsModal from "../../components/openAppointmentsModal/OpenAppointmentsModal";

import { useCallback, useEffect, useState } from "react";
import { TypeCards } from "../../enums/TypeCards";
import {
  ButtonMarkConsulta,
  ContainerCollaboratorInitial,
  DoubleComponents,
  FlexRow,
  ViewAll,
  ViewScroll,
} from "./CollaboratorInitial.styled";

import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../..";
import CollaboratorInitialModalScheduling from "../../components/collaboratorInitial/CollaboratorInitialSchedulingModal";
import { Paths } from "../../enums/Paths";
import SchedulingCard from "../../models/core/scheduling/SchedulingCard";
import CardInformationUser from "../../components/cardInformationUser/CardInformationUser";
import CollaboratorInitialAllAppointments from "../../components/collaboratorInitial/CollaboratorInitialAllAppointments";
import Colors from "../../constants/Colors";
import { FilledButton } from "../../components/UI/buttons/Button";
import BackButton from "../../components/UI/buttons/BackButton";
import { RightButtonContainer } from "../home/Home.styled";
import ExameCard from "../../models/core/exams/ExameCard";
import useResponsiveInfo from "../../hooks/useResponsiveInfo";
import { getCodigoByDescricao, Roles } from "../../enums/Roles";

const CollaboratorInitial = () => {
  const [modalScheduling, setModalScheduling] = useState(false);
  const [showAllAppointments, setShowAllAppointments] = useState(false);
  const [isFetchingPhoto, setIsFetchingPhoto] = useState(true);
  const [showOpenAppointmentsModal, setShowOpenAppointmentsModal] = useState(false);
  const [pendingAppointments, setPendingAppointments] = useState<any[]>([]);

  const userInfoId = useSelector((state: any) => state.login.userInfo.id);
  const { isDesktop, isTablet } = useResponsiveInfo();
  const dispatch = useAppDispatch();

  const resultList: SchedulingCard[] =
    useSelector((state: any) => state.collaborationInitial.scheduling) ?? [];

  const resultExams: ExameCard[] =
    useSelector((state: any) => state.exams.exames) ?? [];

  const { currentProfile } = useSelector((state: any) => state.login);

  const fetchPendingAppointments = useCallback(async () => {
    const rolesToWarn = ["MED", "ENF", "PSI", "NUT", Roles.MED, Roles.ENF, Roles.PSI, Roles.NUT];
    const isHealthProfessional = rolesToWarn.includes(currentProfile);

    if (isHealthProfessional) {
      const appointmentService = new AppointmentService();
      try {
        const response: any = await appointmentService.getPendingAppointments();
        const pendingData = response.data.data || [];

        if (pendingData && pendingData.length > 0) {
          setPendingAppointments(pendingData);
          setShowOpenAppointmentsModal(true);
        }
      } catch (error) {
        console.error("Erro ao buscar atendimentos pendentes:", error);
      }
    }
  }, [currentProfile]);

  useEffect(() => {
    fetchPendingAppointments();
  }, [fetchPendingAppointments]);
  const [showInfo] = useState(currentProfile === getCodigoByDescricao(Roles.ADM)
    || currentProfile === getCodigoByDescricao(Roles.GES) ? false : true)


  const fetchResults = useCallback(async () => {
    await dispatch(collaboratorInitial.getResultsScheduling());
  }, [dispatch, isFetchingPhoto]);

  const fetchExames = useCallback(async () => {
    await dispatch(exams.fetchExams(userInfoId));
  }, [dispatch]);

  useEffect(() => {
    if (!isFetchingPhoto) {
      fetchResults();
      fetchExames();
    }
  }, [fetchResults, isFetchingPhoto]);

  const navigate = useNavigate();

  const onSelectSchedulingCard = (id: string) => {
    navigate(Paths.DetailScheduling, { state: { id } });
  };

  const onSelectExamCard = (id: string, nome: string, data: string) => {
    navigate(Paths.exams, { state: { id, nome, data } });
  };

  const navigationAllExams = () => {
    navigate(Paths.exams);
  };

  return (
    <ContainerWithSidebar>
      <ContainerCollaboratorInitial>
        <FlexRow style={{ marginBottom: "38px" }}>
          <GeneralContainer>
            <CardInformationUser
              isFetchingPhoto={isFetchingPhoto}
              setIsFetchingPhoto={setIsFetchingPhoto}
            />
          </GeneralContainer>
          <RightButtonContainer isTablet={isTablet}>

            <ButtonMarkConsulta
              color="#0a5190"
              onClick={() => {
                setModalScheduling(true);
              }}
              disabled={false}
              isTablet={isTablet}
            >
              Marcar consulta
            </ButtonMarkConsulta>
            {!isTablet && (
              <FilledButton color="#F0F9FF" onClick={() => { }} disabled={false}>
                <MdNotifications style={{ color: "#0A5190" }} size={20} />
              </FilledButton>
            )}
          </RightButtonContainer>
        </FlexRow>
        {showAllAppointments ? (
          <div style={{ width: "100%" }}>
            <BackButton onClick={() => setShowAllAppointments(false)} />
            <CollaboratorInitialAllAppointments
              onSelectCard={onSelectSchedulingCard}
            />
          </div>
        ) : (
          <>
            {showInfo && (<div>
              <DoubleComponents>
                <H2>Consultas agendadas</H2>
                <ViewAll
                  onClick={() => {
                    setShowAllAppointments(true);
                  }}
                >
                  Ver tudo <MdKeyboardArrowRight />
                </ViewAll>
              </DoubleComponents>

              <FlexRow>
                <ViewScroll>
                  {resultList && resultList.length > 0 && (
                    <>
                      {[...resultList]
                        .sort((a, b) =>
                          a.horario < b.horario
                            ? 1
                            : a.horario > b.horario
                              ? -1
                              : 0
                        )
                        .map((dados, index) => (
                          <CardResult
                            key={index}
                            id={dados.id}
                            render={TypeCards.CardConsulta}
                            horario={dados.horario}
                            foto={dados.profissionalFoto}
                            nomeMedico={dados.profissionalNome}
                            titulo={dados.profissionalEspecialidade}
                            unidade={dados.unidadeAtendimentoNome}
                            onClick={onSelectSchedulingCard}
                          />
                        ))}
                    </>
                  )}
                  {resultList.length === 0 && (
                    <>
                      <H1>Você ainda não possui consultas agendadas.</H1>
                    </>
                  )}
                </ViewScroll>
              </FlexRow>
              <DoubleComponents style={{ marginTop: "50px" }}>
                <H2>Resultados de exames</H2>
                <ViewAll
                  onClick={() => {
                    navigationAllExams();
                  }}
                >
                  Ver tudo <MdKeyboardArrowRight />
                </ViewAll>
              </DoubleComponents>
              <FlexRow>
                <ViewScroll>
                  {resultExams && resultExams.length > 0 && (
                    <>
                      {[...resultExams]
                        .sort((a, b) =>
                          a.dataColeta < b.dataColeta
                            ? 1
                            : a.dataColeta > b.dataColeta
                              ? -1
                              : 0
                        )
                        .map((dados, index) => (
                          <CardResult
                            key={index}
                            render={TypeCards.CardExame}
                            horario={dados.dataColeta}
                            titulo={dados.nomeExame}
                            onClick={() =>
                              onSelectExamCard(
                                dados.id,
                                dados.nomeExame,
                                dados.dataColeta
                              )
                            }
                            id={dados.id}
                          />
                        ))}
                    </>
                  )}
                  {resultExams.length === 0 && (
                    <>
                      <H1>Você ainda não possui resultados de exame.</H1>
                    </>
                  )}
                </ViewScroll>
              </FlexRow>
              <DoubleComponents style={{ marginTop: "50px" }}>
                <H2>Comunicados</H2>
                <ViewAll>
                  Ver tudo <MdKeyboardArrowRight />
                </ViewAll>
              </DoubleComponents>
              <FlexRow
                style={{ width: isDesktop ? "90%" : isTablet ? "100%" : "" }}
              >
                <CardAnnouncements image={Foto} title="Conheça os periódicos" />
                <CardAnnouncements image={Foto2} title="Saúde da Mulher" />
              </FlexRow>
            </div>)}
          </>
        )}
      </ContainerCollaboratorInitial>
      <CollaboratorInitialModalScheduling
        modalOpen={modalScheduling}
        onCloseModal={() => setModalScheduling(false)}
      />
      <OpenAppointmentsModal
        visible={showOpenAppointmentsModal}
        appointments={pendingAppointments}
        onConfirm={() => setShowOpenAppointmentsModal(false)}
      />
    </ContainerWithSidebar>
  );
};

export default CollaboratorInitial;
